export const REWARDS_SETUP_GUIDE = {
  title: "Rewards Setup Guide",
  intro: "Use this quick guide to set up rewards in a few minutes.",
  sections: [
    {
      heading: "1) Turn On Rewards",
      bullets: [
        "Switch Rewards to Enabled for this salon.",
        "Points are awarded only when a ticket is CLOSED (not while open).",
      ],
    },
    {
      heading: "2) Set How Clients Earn",
      bullets: [
        "Spend per point: how much a client spends to earn 1 point.",
        "Earn rounding: Floor (drops decimals), Round (nearest), Ceil (always up).",
        "Exclude gift cards or tips if you do not want them to earn points.",
      ],
    },
    {
      heading: "3) Set How Clients Redeem",
      bullets: [
        "Point value: how much 1 point is worth at checkout.",
        "Redeem delay (hours): default 24; set 0 for instant redeem.",
        "Delay prevents same-visit redeem and allows returns/adjustments.",
        "Minimum redeem points and max redeem % control how points are used.",
      ],
    },
    {
      heading: "4) Save Settings",
      bullets: [
        "Click Save Settings after changes.",
        "Review the derived values to confirm your earn rate.",
      ],
    },
    {
      heading: "5) Checkout Expectations",
      bullets: [
        "Open tickets do not earn points yet.",
        "Points appear and are awarded when the ticket is CLOSED.",
        "Redeem delay: newly earned points are pending until the delay passes.",
      ],
    },
  ],
};
